import { FullscreenSpinner } from '@frontend/components/common';
import React from 'react';
import { useLocation } from 'react-router-dom';

import AcceptEula from './accept-eula/accept-eula.component';
import useAuthentication from './authentication.controller';
import BasicLogin from './basic-login/basic-login.component';
import ForgotPasswordConfirmation from './forgot-password/forgot-password-confirmation/forgot-password-confirmation.component';
import ForgotPassword from './forgot-password/forgot-password.component';

export const ID = 'authentication';
export interface Props {
    children: React.ReactNode;
}
export const Authentication = (props: Props) => {
    const viewProps = useAuthentication();
    const { pathname } = useLocation();
    const validPath = pathname.split('/')[1];
    const AuthenticationContent = () => {
        if (validPath === 'forgot-password') {
            return <ForgotPassword />;
        } else if (validPath === 'forgot-password-confirmation') {
            return <ForgotPasswordConfirmation />;
        } else return <BasicLogin callback={viewProps.onLoginSucceeded} />;
    };
    return (
        <div id={ID}>
            {viewProps.authenticated ? (
                !viewProps.user ? (
                    <FullscreenSpinner />
                ) : viewProps.shouldAcceptEula ? (
                    <AcceptEula
                        user={viewProps.user}
                        callback={viewProps.acceptEulaCallback}
                        overrideUrl={viewProps.overrideEulaUrl}
                    />
                ) : (
                    props.children
                )
            ) : (
                <AuthenticationContent />
            )}
        </div>
    );
};
